<template>
  <div :class="$style['modal-transaction']">
    <v-slider>
      <the-tip-selection
        key="tip"
        v-if="view === 'tip'"
        @back="handleBack"
        @handleTipSelection="handleTipSelection"
        @handleContinue="handleTip"
      />
      <the-details-input
        v-if="view === 'details'"
        @back="handleBack"
        @handleContinue="handleDetails"
        :key="1"
      />
      <the-payment-overview
        v-if="view === 'overview'"
        @back="handleBack"
        @handleContinue="handlePay"
      />
    </v-slider>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

const TheTipSelection = () => import('@components/the-tip-selection.vue')
const TheDetailsInput = () => import('@components/the-details-input.vue')
const ThePaymentOverview = () => import('@components/the-payment-overview.vue')
const VSlider = () => import('@components/v-slider.vue')

export default {
  components: {
    TheTipSelection,
    TheDetailsInput,
    ThePaymentOverview,
    VSlider,
  },
  data: () => ({
    view: 'tip',
  }),
  computed: {
    ...mapGetters('ui', ['showTransactionModal']),
  },
  methods: {
    ...mapActions('payment', ['setGratuityAmount', 'setEmailAddress']),
    ...mapActions('ui', ['toggleTransactionModal']),
    handleBack() {
      switch (this.view) {
        case 'tip':
          return this.handleCloseModal()
        case 'details':
          return (this.view = 'tip')
        case 'overview':
          return (this.view = 'details')
        default:
          return
      }
    },
    handleCloseModal() {
      this.toggleTransactionModal({ modalIsVisible: false })
    },
    handlePay() {
      this.handleCloseModal()
    },
    handleTipSelection({ clear, input, percentage }) {
      if (clear) {
        this.setGratuityAmount({ gratuityAmount: null })
        return
      }

      if (percentage || percentage === 0) {
        this.setGratuityAmount({ gratuityAmount: percentage })
      } else if (input) {
        this.setGratuityAmount({ gratuityAmount: input })
      }
    },
    handleTip() {
      this.view = 'details'
    },
    handleDetails(emailAddress) {
      this.setEmailAddress({ emailAddress })
      this.view = 'overview'
    },
  },
  destroyed() {
    const modalIsVisible = this.showTransactionModal

    if (modalIsVisible) {
      this.toggleTransactionModal({ modalIsVisible: false })
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';

.modal-transaction {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
</style>
